type GoogleMapsAuthFailureWindow = Window & { gm_authFailure?: () => void };

/**
 * Google Maps calls `gm_authFailure` globally on any JS-API auth failure — invalid key,
 * billing off, or (the one that bites locally) `RefererNotAllowedMapError` when the page
 * URL isn't in the key's HTTP-referrer allow-list. Registers `onFailure` as that handler
 * (chaining any handler that was already registered) and returns a restore function to
 * call on the component's `ngOnDestroy`.
 */
export function registerGoogleMapsAuthFailureFallback(onFailure: () => void): () => void {
  const globalWindow = window as GoogleMapsAuthFailureWindow;
  const previousHandler = globalWindow.gm_authFailure;
  globalWindow.gm_authFailure = () => {
    previousHandler?.();
    onFailure();
  };
  return () => {
    globalWindow.gm_authFailure = previousHandler;
  };
}
